.CharacterCounter {
  display: flex;
  align-items: center;
  gap: var(--control-xsmall-gap);
  color: var(--fgColor-muted);
}

.CharacterCounter--error {
  color: var(--fgColor-danger);
}
